import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, useParams } from 'react-router-dom';
import { collection, getDoc, doc, setDoc, getDocs, writeBatch, updateDoc } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import styleClasses from './css/MyPage.module.scss';
import { saveUserLog } from './LogandUtils'; // 경로에 맞게 수정

function PushActivity() {
  const [searchParams] = useSearchParams();
  // URL 쿼리에서 activityId 값을 가져와서 쉼표로 구분된 문자열이라면 배열로 변환
  const activityIdsParam = searchParams.get('activityId'); 
  const activityIds = activityIdsParam ? activityIdsParam.split(',') : [];  const navigate = useNavigate();
  const user = auth.currentUser;

  const [musicards, setMusicards] = useState([]);
  // 뮤지카드 선택 (뮤지카드 이름)
  const [selectedMusicard, setSelectedMusicard] = useState('');
  // 내보낼 카테고리 선택: 공연목록은 "stages", 행사목록은 "events"
  const [selectedType, setSelectedType] = useState('stages');

  useEffect(() => {
    if (!user) {
      console.error("사용자가 로그인되어 있지 않습니다.");
      navigate('/login');
      return;
    }
    const fetchMusicards = async () => {
      try {
        const userDoc = await getDoc(doc(db, "users", user.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          const musicardList = Object.entries(userData.musicard || {}).map(([key, value]) => ({
            id: key,
            name: value,
          }));
          setMusicards(musicardList);
        } else {
          console.error("사용자 문서가 존재하지 않습니다.");
        }
      } catch (error) {
        console.error("뮤지카드 가져오기 오류:", error);
      }
    };

    fetchMusicards();
  }, [user, navigate]);

  const handleSubmit = async () => {
    if (!selectedMusicard || !activityIds) {
      alert("뮤지카드와 액티비티를 선택해주세요.");
      return;
    }

    try {
        // 선택된 각 activityId에 대해 처리
        for (const activityId of activityIds) {
          // 1. users_data에서 전체 액티비티 데이터를 가져오기
          const userActivityRef = doc(db, `users_data/${user.uid}/activity/${activityId}`);
          const activitySnap = await getDoc(userActivityRef);
          if (!activitySnap.exists()) {
            alert(`복사할 액티비티 데이터를 찾을 수 없습니다: ${activityId}`);
            continue; // 해당 activityId가 없으면 건너뛰기
          }
          const activityData = activitySnap.data();
  
          // 2. 가져온 액티비티 데이터에 activityId, ownerId를 추가하여 musicians 컬렉션에 저장
          const musicianActivityRef = doc(
            db,
            `musicians/${selectedMusicard}/${selectedType}/${activityId}`
          );
          await setDoc(
            musicianActivityRef,
            {
              ...activityData,
              activityId,
              ownerId: user.uid,
            },
            { merge: true }
          );

          await saveUserLog('musicard_logs', selectedMusicard, 'create', musicianActivityRef.path, 'PushActivity');
  
          // 3. (선택사항) 하위 서브컬렉션 복사
          // 만약 액티비티 문서에 복사할 하위 컬렉션(예: clips 등)이 있다면, getDocs와 writeBatch를 이용해 복사하는 로직을 추가할 수 있습니다.
  
          // 4. users_data의 해당 액티비티 문서에서 act 필드를 업데이트 (기존 act와 병합)
          await setDoc(
            userActivityRef,
            {
              act: {
                [selectedMusicard]: selectedType,
              },
            },
            { merge: true }
          );
        }
  
        alert("뮤지카드에 선택한 액티비티들이 추가되었습니다!");
        navigate('/my-page/activity');
    } catch (error) {
      console.error("액티비티 추가 오류:", error);
      alert("액티비티 추가 중 오류가 발생했습니다.");
    }
  };

  return (
    <div className={styleClasses.pushPage}>
      <h1>뮤지카드로 액티비티 내보내기</h1>
      <div className={styleClasses.form}>
        <label>내 뮤지카드 선택</label>
        <select value={selectedMusicard} onChange={(e) => setSelectedMusicard(e.target.value)}>
          <option value="">뮤지카드를 선택하세요</option>
          {musicards.map((card) => (
            <option key={card.id} value={card.name}>
              {card.name}
            </option>
          ))}
        </select>

        <label>어느 목록으로 내보낼까요?</label>
        <select value={selectedType} onChange={(e) => setSelectedType(e.target.value)}>
          <option value="stages">공연목록 (Performance List)</option>
          <option value="events">행사목록 (Events List)</option>
        </select>

        <button onClick={handleSubmit} className="primaryButton">
          액티비티 내보내기
        </button>
      </div>
    </div>
  );
}

export default PushActivity;